export const iconCalender = ({ theme: { colors } }) => ({
    fill: colors.white,
    height: 13,
    marginRight: 10,
});

export const dash = () => ({
    margin: '0 4px',
});
